import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

export const MainBlock = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9000;
  animation: ${fadeIn} 0.2s ease-out;
`;

export const ModalContainer = styled.div`
  position: relative;
  background: white;
  border: 1px solid ${theme.colors.SurfacePlatinum20};
  border-radius: 12px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: auto;
  animation: ${slideIn} 0.3s ease-out;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
  }

  @media (max-width: 768px) {
    max-width: 100vw;
  }
`;
